import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import { LoadingProvider } from './contexts/LoadingContext';
import AnimatedRoutes from './components/common/AnimatedRoutes';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';

function App() {
    const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

    return (
        <GoogleOAuthProvider clientId={googleClientId}>
            <LoadingProvider>
                <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsAndConditions />} />
                    <Route path="/*" element={<AnimatedRoutes />} />
                </Routes>
            </Router>
                </AuthProvider>
            </LoadingProvider>
        </GoogleOAuthProvider>
    );
}

export default App;
